<template>
  <v-layout row wrap>
    <v-flex offset-md1 md10 class="border-content mt-5 pa-4">
      <div class="company-header">
        Dados principais
      </div>
      <v-container grid-list-sm grid-list-md>
        <v-form name="form-cadastro" ref="company">
          <v-layout row wrap>
            <v-flex xs12 md2 class="logo">
              <!-- <div class="block-logo"></div> -->
              <div v-if="!isImage" class="outerDiv">
                <img :src="company.logo" alt="" class="img-responsive">
                <div class="photo-actions">
                  <div class="alter">
                    <v-icon>insert_photo</v-icon> Alterar
                    <input class="invisible-all" type="file" name="" value="" v-on:change="shelfLogo">
                  </div>
                  <div class="remove" @click="removeLogo">
                    <v-icon>close</v-icon> Remover
                  </div>
                </div>
              </div>
              <template v-else>
                <div class="outerDiv" v-if="shelfedLogo !== ''">
                  <img :src="shelfedLogo"  alt="" class="img-responsive">
                  <div class="photo-actions">
                    <div class="alter">
                      <v-icon>insert_photo</v-icon> Alterar
                      <input class="invisible-all" type="file" name="" value="" v-on:change="shelfLogo">
                    </div>
                    <div class="remove" @click="unshelfLogo" >
                      <v-icon>close</v-icon> Remover
                    </div>
                  </div>
                </div>
                <template v-else>
                  <input class="invisible-all" type="file" name="" value="" v-on:change="shelfLogo">
                  <div class="outerDiv">
                    <div class="pa-2 noselect foto">
                      <v-icon>insert_photo</v-icon>
                      adicionar um logo
                    </div>
                  </div>
                </template>
              </template>
            </v-flex>
              <v-flex xs12 sm6 md4 offset-md1>
                <v-text-field
                  label="Nome do seu negócio"
                  hint="Nome fantasia"
                  :value="company.tradingName"
                  @input="updateTradingName"
                  :rules="rules.tradingName"
                  :count="60"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md5>
                <v-text-field
                  label="Documento"
                  hint="CPF/CNPJ"
                  v-model="company.document"
                  :mask="company.document.length > 11 ? '##.###.###/####-##' : '###.###.###-###'"
                  :validate-on-blur="true"
                  required
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  label="E-mail corporativo"
                  :value="company.email"
                  @input="updateEmail"
                  :validate-on-blur="true"
                  disabled
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  label="Telefone corporativo"
                  :value="company.phone"
                  @input="updatePhone"
                  :mask="company.phone.length === 11 ? '(##) #####-####' : '(##) ####-#####'"
                  hint="DDD + Numero"
                  persistent-hint
                  :rules="rules.phone"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  label="Website"
                  :value="company.site"
                  :rules="rules.site"
                  @input="updateSite"
                  :validate-on-blur="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field :value="company.description" @keydown="limitChar($event, 140)" :rules="rules.description" @input="updateDescription" multi-line label="Descrição da Empresa" :counter="140"></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
    </v-flex>
    <v-flex offset-md1 md10 class="border-content mt-5 pa-4">
      <div class="company-header">
        Endereço
      </div>
      <v-container grid-list-sm grid-list-md>
        <v-form name="form-cadastro" ref="address">
          <v-layout row wrap>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  label="CEP"
                  class="spinner"
                  mask="#####-###"
                  :rules="rules.zipCode"
                  v-model="fieldZipCode"
                  :append-icon="loadingZipCode ? 'autorenew' : ''"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md5>
                <v-text-field
                  label="Endereço"
                  :value="company.address"
                  :rules="rules.address"
                  @input="updateAddress"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  label="Numero"
                  :value="company.addressNumber"
                  :rules="rules.addressNumber"
                  type="number"
                  @input="updateAddressNumber"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  label="Complemento"
                  :value="company.complement"
                  :rules="rules.complement"
                  @input="updateComplement"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Bairro"
                  :value="company.neighborhood"
                  :rules="rules.neighborhood"
                  @input="updateNeighborhood"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
              <v-autocomplete
                  v-if="listStatesCities !== null"
                  v-bind:items="listStatesCities"
                  item-text="name"
                  item-value="initials"
                  label="Estado"
                  :rules="rules.state"
                  :value="company.state"
                  @input="updateState"
                  single-line
                  bottom
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  v-if="citiesList !== null"
                  v-bind:items="citiesList"
                  label="Cidade"
                  single-line
                  :disabled="loadedCities"
                  :rules="rules.city"
                  :value="company.city"
                  @input="updateCity"
                  bottom
                  required
                ></v-autocomplete >
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
    </v-flex>
    <v-flex offset-md1 md10 class="border-content mt-5 pa-4">
      <div class="company-header">
        O tipo de serviço que sua empresa presta requer definição de horários?
        <v-tooltip right>
          <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
          <span>Coloque sim, caso o tipo de serviço prestado pela sua empresa tenha horários de atendimentos diferenciados durante a semana.</span>
        </v-tooltip>    
          
      </div>
      <v-container grid-list-sm grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12>
            <SelectionBtn class="font-14" :value="needSchedule" @input="toggleNeedSchedule"/> 
          </v-flex>
        </v-layout>
        
        <v-layout  row wrap v-if="needSchedule">
          <v-flex xs4 sm3 md2>
            <p class="mt-4 mb-0">Sábado</p>
          </v-flex>
          <v-flex xs6 sm3 md2 class="pr-3">
            <v-text-field
              label="Início"
              :value="company.saturdayStart"
              @change="updateSaturdayStart"
              mask="##:##"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs6 sm3 md2 class="pr-3">
            <v-text-field
              label="Fim"
              :value="company.saturdayEnd"
              @change="updateSaturdayEnd"
              mask="##:##"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Tempo de atendimento"
              :value="company.saturdayInterval"
              @change="updateSaturdayInterval"
              mask="##:##"
              masked="true"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Qual é o tempo médio de realização dos serviços.</span>
            </v-tooltip> 
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Atendimentos simultâneos"
              :value="company.saturdayCapacity"
              @change="updateSaturdayCapacity"
              >
            </v-text-field>  
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
            </v-tooltip>
          </v-flex>
        </v-layout>  
        <v-layout  row wrap v-if="needSchedule">
          <v-flex xs4 sm3 md2>
            <p class="mt-4 mb-0">Domingo</p>
          </v-flex>
          <v-flex xs4 sm3 md2 class="pr-3">
            <v-text-field
              label="Início"
              :value="company.sundayStart"
              @change="updateSundayStart"
              mask="##:##"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs6 sm3 md2 class="pr-3">
            <v-text-field
              label="Fim"
              :value="company.sundayEnd"
              @change="updateSundayEnd"
              mask="##:##"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Tempo de atendimento"
              :value="company.sundayInterval"
              @change="updateSundayInterval"
              mask="##:##"
              masked="true"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Qual é o tempo médio de realização dos serviços.</span>
            </v-tooltip> 
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Atendimentos simultâneos"
              :value="company.sundayCapacity"
              @change="updateSundayCapacity"
              >
            </v-text-field>  
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
        <v-layout  row wrap v-if="needSchedule">
          <template v-if="!customTime">
          <v-flex xs4 sm3 md2>
            <p class="mt-4 mb-0">Segunda a Sexta</p>
          </v-flex>
          <v-flex xs6 sm3 md2 class="pr-3">
            <v-text-field
              label="Início"
              :value="company.weekDayStart"
              @change="updateWeekdayStart"
              mask="##:##"
              masked="true"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs6 sm3 md2 class="pr-3">
            <v-text-field
              label="Fim"
              :value="company.weekDayEnd"
              @change="updateWeekdayEnd"
              mask="##:##"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Tempo de atendimento"
              :value="company.weekDayInterval"
              @change="updateWeekdayInterval"
              mask="##:##"
              masked="true"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Qual é o tempo médio de realização dos serviços.</span>
            </v-tooltip> 
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Atendimentos simultâneos"
              :value="company.weekDayCapacity"
              @change="updateWeekdayCapacity"
              >
            </v-text-field>  
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
            </v-tooltip>
          </v-flex>
          </template>
          <template v-else>
            <v-flex xs12 sm3 md2>
              <p class="mt-4 mb-0">Segunda</p>
            </v-flex>
            <v-flex xs6 sm3 md2 class="pr-3">
              <v-text-field
                label="Início"
                :value="company.mondayStart"
                @change="updateMondayStart"
                mask="##:##"
                >
              </v-text-field>
            </v-flex>
            <v-flex xs6 sm3 md2 class="pr-3">
              <v-text-field
                label="Fim"
                :value="company.mondayEnd"
                @change="updateMondayEnd"
                mask="##:##"
                >
              </v-text-field>
            </v-flex>
            <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Tempo de atendimento"
              :value="company.mondayInterval"
              @change="updateMondayInterval"
              mask="##:##"
              masked="true"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Qual é o tempo médio de realização dos serviços.</span>
            </v-tooltip> 
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Atendimentos simultâneos"
              :value="company.mondayCapacity"
              @change="updateMondayCapacity"
              >
            </v-text-field>  
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
            </v-tooltip>
          </v-flex>
          </template>
        </v-layout>
        <v-layout  row wrap v-if="needSchedule && customTime">
          <v-flex xs4 sm3 md2>
            <p class="mt-4 mb-0">Terça</p>
          </v-flex>
          <v-flex xs6 sm3 md2 class="pr-3">
            <v-text-field
              label="Início"
              :value="company.tuesdayStart"
              @change="updateTuesdayStart"
              mask="##:##"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs6 sm3 md2 class="pr-3">
            <v-text-field
              label="Fim"
              :value="company.tuesdayEnd"
              @change="updateTuesdayEnd"
              mask="##:##"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Tempo de atendimento"
              :value="company.tuesdayInterval"
              @change="updateTuesdayInterval"
              mask="##:##"
              masked="true"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Qual é o tempo médio de realização dos serviços.</span>
            </v-tooltip> 
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Atendimentos simultâneos"
              :value="company.tuesdayCapacity"
              @change="updateTuesdayCapacity"
              >
            </v-text-field>  
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
        <v-layout  row wrap v-if="needSchedule && customTime">
          <v-flex xs4 sm3 md2>
            <p class="mt-4 mb-0">Quarta</p>
          </v-flex>
          <v-flex xs6 sm3 md2 class="pr-3">
            <v-text-field
              label="Início"
              :value="company.wednesdayStart"
              @change="updateWednesdayStart"
              mask="##:##"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs6 sm3 md2 class="pr-3">
            <v-text-field
              label="Fim"
              :value="company.wednesdayEnd"
              @change="updateWednesdayEnd"
              mask="##:##"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Tempo de atendimento"
              :value="company.wednesdayInterval"
              @change="updateWednesdayInterval"
              mask="##:##"
              masked="true"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Qual é o tempo médio de realização dos serviços.</span>
            </v-tooltip> 
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Atendimentos simultâneos"
              :value="company.wednesdayCapacity"
              @change="updateWednesdayCapacity"
              >
            </v-text-field>  
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
        <v-layout  row wrap v-if="needSchedule && customTime">
          <v-flex xs4 sm3 md2>
            <p class="mt-4 mb-0">Quinta</p>
          </v-flex>
          <v-flex xs6 sm3 md2 class="pr-3">
            <v-text-field
              label="Início"
              :value="company.thursdayStart"
              @change="updateThursdayStart"
              mask="##:##"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs6 sm3 md2 class="pr-3">
            <v-text-field
              label="Fim"
              :value="company.thursdayEnd"
              @change="updateThursdayEnd"
              mask="##:##"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Tempo de atendimento"
              :value="company.thursdayInterval"
              @change="updateThursdayInterval"
              mask="##:##"
              masked="true"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Qual é o tempo médio de realização dos serviços.</span>
            </v-tooltip> 
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Atendimentos simultâneos"
              :value="company.thursdayCapacity"
              @change="updateThursdayCapacity"
              >
            </v-text-field>  
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
        <v-layout  row wrap v-if="needSchedule && customTime">
          <v-flex xs4 sm3 md2>
            <p class="mt-4 mb-0">Sexta</p>
          </v-flex>
          <v-flex xs6 sm3 md2 class="pr-3">
            <v-text-field
              label="Início"
              :value="company.fridayStart"
              @change="updateFridayStart"
              mask="##:##"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs6 sm3 md2 class="pr-3">
            <v-text-field
              label="Fim"
              :value="company.fridayEnd"
              @change="updateFridayEnd"
              mask="##:##"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Tempo de atendimento"
              :value="company.fridayInterval"
              @change="updateFridayInterval"
              mask="##:##"
              masked="true"
              >
            </v-text-field>
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Qual é o tempo médio de realização dos serviços.</span>
            </v-tooltip> 
          </v-flex>
          <v-flex xs5 sm3 md2 class="pr-3">
            <v-text-field
              label="Atendimentos simultâneos"
              :value="company.fridayCapacity"
              @change="updateFridayCapacity"
              >
            </v-text-field>  
          </v-flex>
          <v-flex xs1 sm1 md1 class="pr-3">
            <v-tooltip right>
              <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
              <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="needSchedule">
          <v-flex xs12 sm3 md6>
            <p class="">Horários distintos durante a semana</p>
            <SelectionBtn :value="customTime" @input="toggleCustomTime"/>
            <v-tooltip right>
              <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
              <span>Se o tipo de serviço prestado pela sua empresa tem horários de atendimentos diferenciados durante a semana, preencha a próxima tela.</span>
            </v-tooltip>    
          </v-flex>
        </v-layout>
          
          
      </v-container>
    </v-flex>
    <v-flex offset-md1 md10 mt-3 mb-3>
      <v-btn
        round
        :loading="loadingCompany"
        @click.native="loader = 'loading'"
        :disabled="loadingCompany"
        class="btn-green spinner"
        v-on:click='updateCompany'
      >
        Atualizar
        <span slot="loader">
          <v-icon light>cached</v-icon>
        </span>
      </v-btn>
    </v-flex>
    <v-dialog :value="waitingApproval" @input="toggleWaitingApproval" max-width="600px">
      <v-card>
        <v-card-title>
          <v-flex>
            <h4>Homologação</h4>
          </v-flex>
        </v-card-title>
        <v-card-text>
          Dentro de 24 horas voce será homologado, demoro?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="toggleWaitingApproval(false)">Entendi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  tem que ter mas nao tem por isso false -->
    <v-flex offset-md1 md10 class="border-content mt-5 pa-3" v-show="false">
      <div>
        Área de atendimento
      </div>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliquam
      <v-container grid-list-sm grid-list-md>
        <v-form name="form-cadastro" :value="true">
          <v-layout row wrap>
            <v-flex xs12 sm3 md4>
              <v-checkbox label="Brasil" v-model="areaSelecionada" value="Brasil"></v-checkbox>
            </v-flex>
            <v-flex xs12 sm3 md4>
              <v-checkbox label="Estados" v-model="areaSelecionada" value="Estados"></v-checkbox>
            </v-flex>
            <v-flex xs12 sm3 md4>
              <v-checkbox label="Cidade" v-model="areaSelecionada" value="Cidade"></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout v-show="estados !== ''">
            <v-flex xs12 sm3 md2 offset-md1>
              <v-checkbox label="Centro" v-model="zonaAtendimento" value="Centro"></v-checkbox>
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-checkbox label="Leste" v-model="zonaAtendimento" value="Leste"></v-checkbox>
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-checkbox label="Oeste" v-model="zonaAtendimento" value="Oeste"></v-checkbox>
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-checkbox label="Norte" v-model="zonaAtendimento" value="Norte"></v-checkbox>
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-checkbox label="Sul" v-model="zonaAtendimento" value="Sul"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-flex>
    <v-dialog v-model="homologationDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Homologação</v-card-title>
        <v-card-text>Aguarde, as informações estão sendo homologadas pela nossa equipe.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click.native="homologationDialog = false">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<!-- <script type="text/javascript" src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDiVQFUT_bhI-z61dne8sb5J517cNaDf8M&libraries=places"></script> -->
<script>
import listStatesCities from './StatesCities.js'
import SelectionBtn from '@/components/SelectionBtn'
export default {
  name: 'Empresa',
  components: {
    SelectionBtn
  },
  data () {
    return {
      homologationDialog: false,
      pesquisar: '',
      title: 'ew',
      listStatesCities: listStatesCities,
      areaSelecionada: 'Brasil',
      zonaAtendimento: [],
      estados: '',
      rules: {
        tradingName: [
          (v) => v.length > 2 || 'Precisa conter no minimo 3 caracteres',
          (v) => v.length < 51 || 'Nome fantasia inválido'
        ],
        phone: [
          (v) => !/[^0-9() -\W]{1,15}/.test(v) || 'Telefone inválido',
          (v) => !!v || 'Telefone em branco',
          (v) => v.length < 12 || 'Telefone inválido',
          (v) => v.length > 9 || 'Telefone inválido'
        ],
        description: [
          (v) => v.length > 0 || 'Insira uma descrição',
          (v) => v.length < 141 || 'Descrição inválida'
        ],
        zipCode: [
          (v) => v.length > 0 || 'Insira um Cep',
          (v) => v.length < 10 || 'Cep inválido'
        ],
        address: [
          (v) => v.length > 0 || 'Insira um endereço',
          (v) => v.length < 151 || 'Endereço inválido'
        ],
        addressNumber: [
          (v) => v.length > 0 || 'Insira um numero',
          (v) => v.length < 141 || 'Numero inválido'
        ],
        complement: [
          (v) => v.length < 551 || 'complemento inválido'
        ],
        neighborhood: [
          (v) => v.length > 2 || 'Bairro inválido',
          (v) => v.length < 51 || 'Bairro inválido'
        ],
        state: [
          (v) => v.length === 2 || 'Estado inválido',
          (v) => this.listStatesCities.filter(elem => elem.initials === v).length === 1 || 'Estado inválido'
        ],
        city: [
          (v) => v.length > 0 || 'Cidade inválida',
          (v) => this.citiesList.filter(elem => elem === v).length === 1 || 'Cidade inválida'

        ]
      }
    }
  },
  methods: {
    updateCompany () {
      // codigo adaptação do legado verificar possiveis erros de grafia
      let validate = true
      let state = this.listStatesCities.filter(elem => elem.initials === this.company.state)
      if (state.length === 0) {
        validate = false
      } else {
        let city = state[0].cities.filter(elem => elem === this.company.city)
        if (city.length === 0) {
          validate = false
        }
      }
      if (this.$refs.address.validate() && this.$refs.company.validate() && validate) {
        this.$store.dispatch('updateCompany').then(() => {
          this.hasHomologationDialog()
        })
      } else {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'Verifique os campos em vermelho'
        })
      }
    },
    hasHomologationDialog () {
      if (this.$store.getters.statusCode === 3) {
        this.homologationDialog = true
      }
    },
    limitChar (elem, limit) {
      if (elem.target.value.length === limit && elem.key !== 'Backspace') {
        elem.preventDefault()
      }
    },
    removeLogo () {
      this.$store.commit('updateLogo', '')
    },
    updateLogo (value) {
      this.$store.commit('updateLogo', value)
    },
    updateTradingName (value) {
      this.$store.commit('updateTradingName', value)
    },
    updateDocument (value) {
      this.$store.commit('updateDocument', value)
    },
    updatePhone (value) {
      this.$store.commit('updatePhone', value)
    },
    updateEmail (value) {
      this.$store.commit('updateEmail', value)
    },
    updateDescription (value) {
      this.$store.commit('updateDescription', value)
    },
    updateSite (value) {
      this.$store.commit('updateSite', value)
    },
    updateZipCode (value) {
      this.$store.commit('updateZipCode', value)
    },
    updateAddress (value) {
      this.$store.commit('updateAddress', value)
    },
    updateAddressNumber (value) {
      this.$store.commit('updateAddressNumber', value)
    },
    updateComplement (value) {
      this.$store.commit('updateComplement', value)
    },
    updateNeighborhood (value) {
      this.$store.commit('updateNeighborhood', value)
    },
    updateState (value) {
      this.$store.commit('updateState', value)
    },
    updateCity (value) {
      this.$store.commit('updateCity', value)
    },
    toggleWaitingApproval (value) {
      this.$store.commit('toggleWaitingApproval', value)
    },
    shelfLogo (elem) {
      let image = {
        elem: elem.target.files[0],
        size: elem.target.files[0].size,
        extension: elem.target.value.substring(elem.target.value.lastIndexOf('.') + 1).toLowerCase()
      }
      if (image.size > 3000000) {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Insira uma image de até 3mb'
        })
        return
      }
      if (image.extension === 'gif' || image.extension === 'png' || image.extension === 'bmp' ||
      image.extension === 'jpeg' || image.extension === 'jpg') {
        // if (image.extension !== 'png') {
        //   this.$store.commit('toastr', {
        //     color: 'info',
        //     texto: 'Insira uma imagem de preferência com o fundo transparente'
        //   })
        // }
        this.$store.dispatch('shelfLogo', image.elem)
      } else {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Insira uma imagem com a extensão .png'
        })
      }
    },
    unshelfLogo () {
      this.$store.commit('unshelfLogo')
    },
    // getListaDeEstados () {
    //   this.$http.get('https://gist.githubusercontent.com/letanure/3012978/raw/36fc21d9e2fc45c078e0e0e07cce3c81965db8f9/estados-cidades.json').then((response) => {
    //     this.listStatesCities = response.data.estados
    //   })
    // },
    removerFoto (elem) {
      this.$store.dispatch('deleteImages', 'url')
    },
    toggleNeedSchedule () {
      this.$store.commit('toggleNeedSchedule')
    },
    toggleCustomTime () {
      this.$store.commit('toggleCustomTime')
    },
    updateWeekdayStart (value) {
      this.$store.commit('updateWeekdayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateWeekdayEnd (value) {
      this.$store.commit('updateWeekdayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateWeekdayInterval (value) {
      this.$store.commit('updateWeekdayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateWeekdayCapacity (value) {
      this.$store.commit('updateWeekdayCapacity', value)
    },
    updateSundayStart (value) {
      this.$store.commit('updateSundayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateSundayEnd (value) {
      this.$store.commit('updateSundayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateSundayInterval (value) {
      this.$store.commit('updateSundayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateSundayCapacity (value) {
      this.$store.commit('updateSundayCapacity', value)
    },
    updateMondayStart (value) {
      this.$store.commit('updateMondayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateMondayEnd (value) {
      this.$store.commit('updateMondayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateMondayInterval (value) {
      this.$store.commit('updateMondayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateMondayCapacity (value) {
      this.$store.commit('updateMondayCapacity', value)
    },
    updateTuesdayStart (value) {
      this.$store.commit('updateTuesdayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateTuesdayEnd (value) {
      this.$store.commit('updateTuesdayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateTuesdayInterval (value) {
      this.$store.commit('updateTuesdayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateTuesdayCapacity (value) {
      this.$store.commit('updateTuesdayCapacity', value)
    },
    updateWednesdayStart (value) {
      this.$store.commit('updateWednesdayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateWednesdayEnd (value) {
      this.$store.commit('updateWednesdayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateWednesdayInterval (value) {
      this.$store.commit('updateWednesdayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateWednesdayCapacity (value) {
      this.$store.commit('updateWednesdayCapacity', value)
    },
    updateThursdayStart (value) {
      this.$store.commit('updateThursdayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateThursdayEnd (value) {
      this.$store.commit('updateThursdayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateThursdayInterval (value) {
      this.$store.commit('updateThursdayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateThursdayCapacity (value) {
      this.$store.commit('updateThursdayCapacity', value)
    },
    updateFridayStart (value) {
      this.$store.commit('updateFridayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateFridayEnd (value) {
      this.$store.commit('updateFridayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateFridayInterval (value) {
      this.$store.commit('updateFridayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateFridayCapacity (value) {
      this.$store.commit('updateFridayCapacity', value)
    },
    updateSaturdayStart (value) {
      this.$store.commit('updateSaturdayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateSaturdayEnd (value) {
      this.$store.commit('updateSaturdayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateSaturdayInterval (value) {
      this.$store.commit('updateSaturdayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateSaturdayCapacity (value) {
      this.$store.commit('updateSaturdayCapacity', value)
    }
  },
  computed: {
    waitingApproval () {
      return this.$store.getters.waitingApproval
    },
    citiesList () {
      if (this.company.state === '' || this.company.state === undefined) {
        return []
      } else {
        return this.listStatesCities.filter(elem => elem.initials === this.company.state)[0].cities
      }
    },
    loadedCities () {
      return this.citiesList.length === 0
    },
    company () {
      return this.$store.getters.company
    },
    isImage () {
      return this.$store.getters.isImage
    },
    shelfedLogo () {
      return this.$store.getters.shelfedLogo
    },
    listaKm () {
      let retorno = []
      for (let i = 1; i < 50; i++) {
        retorno.push(i)
      }
      return retorno
    },
    loadingZipCode () {
      return this.$store.getters.loadingZipCode
    },
    loadingCompany () {
      return this.$store.getters.loadingCompany
    },
    fieldZipCode: {
      get () {
        return this.company.zipCode
      },
      set (value) {
        this.updateZipCode(value)
        if (this.fieldZipCode.length === 8) {
          this.$store.dispatch('zipCodeSearch')
        }
      }
    },
    needSchedule () {
      return this.$store.getters.company.needSchedule
    },
    customTime () {
      return this.$store.getters.company.customTime
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyData').then(() => {
      this.$refs.address.validate()
      this.$refs.company.validate()
    })
    // esperando homologação
    this.hasHomologationDialog()
  }
}
</script>
<style>
.spinner i{
animation: loader 1s infinite;
display: flex;
}
@-moz-keyframes loader {
from {
  transform: rotate(0);
}
to {
  transform: rotate(360deg);
}
}
@-webkit-keyframes loader {
from {
  transform: rotate(0);
}
to {
  transform: rotate(360deg);
}
}
@-o-keyframes loader {
from {
  transform: rotate(0);
}
to {
  transform: rotate(360deg);
}
}
@keyframes loader {
from {
  transform: rotate(0);
}
to {
  transform: rotate(360deg);
}
}
.border-content{
  border: 1px solid #d6d8d9;
  border-radius: 8px;
}
.invisible-all{
  z-index: 1;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  width: 100%;
}
.logo{
  position: relative;
}
.outerDiv{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
input[type=file]::-webkit-file-upload-button {
  display: none;
}
.photo-actions > div > i{
  color:#fff!important
}
.photo-actions > div{
  float: left;
  width: 50%;
  position: absolute;
  text-align: center;
  bottom: 0;
  cursor: pointer;
}
.photo-actions .remove{
  right: 0;
}
.photo-actions{
  position: absolute;
  bottom: 0;
  top: 0;
  width: 100%;
  color:#fff!important;
  background-size: cover;
  background-image: url('https://www.ettravel.com/wp-content/uploads/2016/06/GRADIENT-OVERLAY.png');
}
.company-header{
  font-size: 20px;
  color: #eb1c24;
}
.block-logo{
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  cursor: not-allowed;
}
.font-14{font-size:14px;}
</style>



// WEBPACK FOOTER //
// empresa.vue?5c37225e